(function () {
  const HEADING = /sp[ée]cificit[ée]s?\s+de\s+chaque\s+couteau/i;

  function textOf(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function findHeading(root) {
    const nodes = root.querySelectorAll('h1, h2, h3, h4, p, div, span');
    let match = null;
    for (const el of nodes) {
      if (!HEADING.test(textOf(el))) continue;
      const childHit = [...el.children].some((child) => HEADING.test(textOf(child)));
      if (childHit) continue;
      return el.closest('h1, h2, h3, h4') || el;
    }
    return match;
  }

  function boundaryAfter(heading, root) {
    for (const node of root.querySelectorAll('ul, table, h2')) {
      if (node.contains(heading) || heading.contains(node)) continue;
      if (!(heading.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_FOLLOWING)) continue;
      if (node.matches('ul, table') && node.querySelector('img')) continue;
      return node;
    }
    return null;
  }

  function imagesBefore(heading, end) {
    const root = heading.closest('.mrg-specs__body, .mrg-product-description-drawer__content');
    return [...root.querySelectorAll('img')].filter((img) => {
      if (!(heading.compareDocumentPosition(img) & Node.DOCUMENT_POSITION_FOLLOWING)) return false;
      if (end && !(end.compareDocumentPosition(img) & Node.DOCUMENT_POSITION_PRECEDING)) return false;
      return true;
    });
  }

  function htmlBetween(start, endNode) {
    const range = document.createRange();
    range.setStartAfter(start);
    range.setEndBefore(endNode);
    const frag = range.cloneContents();
    frag.querySelectorAll('img, meta, script, style').forEach((node) => node.remove());
    return frag;
  }

  function removeBetween(heading, end, root) {
    const doomed = [];
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT);
    let passed = false;
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (node === heading) {
        passed = true;
        continue;
      }
      if (!passed || heading.contains(node) || node.closest('.mrg-knife-carousel')) continue;
      if (end && (node === end || node.contains(end))) continue;
      if (end && !(end.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_PRECEDING)) continue;
      doomed.push(node);
    }
    doomed.reverse().forEach((node) => {
      if (node.parentNode) node.parentNode.removeChild(node);
    });
  }

  function chevron(dir) {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 16 16');
    svg.setAttribute('width', '16');
    svg.setAttribute('height', '16');
    svg.setAttribute('aria-hidden', 'true');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', dir === 'prev' ? 'M10 3.5 5.5 8 10 12.5' : 'M6 3.5 10.5 8 6 12.5');
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '1.6');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    svg.appendChild(path);
    return svg;
  }

  function build(heading, imgs) {
    const carousel = document.createElement('div');
    carousel.className = 'mrg-knife-carousel';
    const track = document.createElement('div');
    track.className = 'mrg-knife-carousel__track';
    track.tabIndex = 0;

    imgs.forEach((img, index) => {
      const slide = document.createElement('article');
      slide.className = 'mrg-knife-carousel__slide';
      slide.setAttribute('aria-label', 'Couteau ' + (index + 1) + ' sur ' + imgs.length);
      const copy = document.createElement('div');
      copy.className = 'mrg-knife-carousel__copy';
      copy.appendChild(htmlBetween(index === 0 ? heading : imgs[index - 1], img));
      if (textOf(copy)) slide.appendChild(copy);

      const figure = document.createElement('figure');
      figure.className = 'mrg-knife-carousel__figure';
      const picture = img.cloneNode(true);
      picture.removeAttribute('style');
      picture.removeAttribute('width');
      picture.removeAttribute('height');
      figure.appendChild(picture);
      slide.appendChild(figure);
      track.appendChild(slide);
    });

    carousel.appendChild(track);

    if (imgs.length > 1) {
      const prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'mrg-knife-carousel__nav mrg-knife-carousel__nav--prev';
      prev.setAttribute('aria-label', 'Couteau précédent');
      prev.appendChild(chevron('prev'));
      const next = document.createElement('button');
      next.type = 'button';
      next.className = 'mrg-knife-carousel__nav mrg-knife-carousel__nav--next';
      next.setAttribute('aria-label', 'Couteau suivant');
      next.appendChild(chevron('next'));
      const dots = document.createElement('div');
      dots.className = 'mrg-knife-carousel__dots';
      const dotButtons = imgs.map((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'mrg-knife-carousel__dot';
        dot.setAttribute('aria-label', 'Couteau ' + (index + 1));
        dots.appendChild(dot);
        return dot;
      });

      function indexNow() {
        const width = track.clientWidth || 1;
        return Math.max(0, Math.min(imgs.length - 1, Math.round(track.scrollLeft / width)));
      }

      function go(index) {
        const width = track.clientWidth || 1;
        track.scrollTo({ left: index * width, behavior: 'smooth' });
      }

      function paint() {
        const current = indexNow();
        prev.disabled = current === 0;
        next.disabled = current === imgs.length - 1;
        dotButtons.forEach((dot, index) => {
          dot.setAttribute('aria-current', index === current ? 'true' : 'false');
        });
      }

      prev.addEventListener('click', () => go(indexNow() - 1));
      next.addEventListener('click', () => go(indexNow() + 1));
      dotButtons.forEach((dot, index) => dot.addEventListener('click', () => go(index)));
      track.addEventListener('scroll', () => paint(), { passive: true });
      carousel.append(prev, next, dots);
      requestAnimationFrame(paint);
    }

    return carousel;
  }

  function mount(root) {
    if (root.dataset.mrgKnifeCarousel === 'ready') return;
    const heading = findHeading(root);
    if (!heading) return;
    const end = boundaryAfter(heading, root);
    const imgs = imagesBefore(heading, end);
    if (!imgs.length) return;
    const carousel = build(heading, imgs);
    heading.after(carousel);
    removeBetween(heading, end, root);
    root.dataset.mrgKnifeCarousel = 'ready';
  }

  function blockFor(img) {
    const own = img.closest('p, li');
    if (own && own.querySelector('strong, b') && textOf(own).length > 40) return own;
    let prev = (own || img).previousElementSibling;
    if (prev && prev.matches('ul, ol')) {
      const items = [...prev.querySelectorAll('li')].filter((li) => !li.querySelector('img'));
      if (items.length) return items[items.length - 1];
    }
    for (let i = 0; i < 3 && prev; i += 1) {
      if (prev.querySelector && prev.querySelector('strong, b')) return prev;
      prev = prev.previousElementSibling;
    }
    return own;
  }

  function knifeName(block, img) {
    const strongs = block ? [...block.querySelectorAll('strong, b')] : [];
    let name = strongs.map((node) => textOf(node)).join(' ').replace(/\s+/g, ' ').trim();
    name = name.replace(/^le\s+/i, '').replace(/\s*\(.*$/, '').replace(/:$/, '').trim();
    if (!name) {
      name = (img.getAttribute('alt') || '').replace(/\s*dimensions?\s*/i, '').trim();
    }
    return name;
  }

  function knifeDesc(block, name) {
    if (!block) return '';
    const clone = block.cloneNode(true);
    clone.querySelectorAll('a').forEach((node) => {
      node.replaceWith(document.createTextNode(node.textContent || ''));
    });
    clone.querySelectorAll('img, meta, script, style').forEach((node) => node.remove());
    let text = textOf(clone).replace(/\s*\(\d+\s*g\)\s*/i, ' ').replace(/\s+/g, ' ').trim();
    text = text.replace(/^le\s+/i, '');
    if (name && text.toLowerCase().startsWith(name.toLowerCase())) {
      let rest = text.slice(name.length).replace(/^[\s:.;]+/, '');
      if (!/^[A-ZÀ-Ý«"]/.test(rest)) {
        const next = rest.replace(/^.*?[.!?]\s+/, '');
        if (next && /^[A-ZÀ-Ý«"]/.test(next)) rest = next;
      }
      if (rest) text = rest;
    }
    return text.replace(/^[:：]\s*/, '').replace(/\s*Note\s*:.*$/i, '').trim();
  }

  function buildSlides(slides) {
    const carousel = document.createElement('div');
    carousel.className = 'mrg-knife-carousel';
    const track = document.createElement('div');
    track.className = 'mrg-knife-carousel__track';
    track.tabIndex = 0;

    slides.forEach((slideData, index) => {
      const slide = document.createElement('article');
      slide.className = 'mrg-knife-carousel__slide';
      slide.setAttribute('aria-label', slideData.name || 'Couteau ' + (index + 1));
      if (slideData.name || slideData.desc) {
        const copy = document.createElement('div');
        copy.className = 'mrg-knife-carousel__copy';
        if (slideData.name) {
          const title = document.createElement('h3');
          title.className = 'mrg-knife-carousel__name';
          title.textContent = slideData.name;
          copy.appendChild(title);
        }
        if (slideData.desc) {
          const desc = document.createElement('p');
          desc.className = 'mrg-knife-carousel__desc';
          desc.textContent = slideData.desc;
          copy.appendChild(desc);
        }
        slide.appendChild(copy);
      }
      const figure = document.createElement('figure');
      figure.className = 'mrg-knife-carousel__figure';
      const picture = slideData.img.cloneNode(true);
      picture.removeAttribute('style');
      picture.removeAttribute('width');
      picture.removeAttribute('height');
      figure.appendChild(picture);
      slide.appendChild(figure);
      track.appendChild(slide);
    });

    carousel.appendChild(track);
    if (slides.length > 1) {
      const prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'mrg-knife-carousel__nav mrg-knife-carousel__nav--prev';
      prev.setAttribute('aria-label', 'Couteau précédent');
      prev.appendChild(chevron('prev'));
      const next = document.createElement('button');
      next.type = 'button';
      next.className = 'mrg-knife-carousel__nav mrg-knife-carousel__nav--next';
      next.setAttribute('aria-label', 'Couteau suivant');
      next.appendChild(chevron('next'));
      const dots = document.createElement('div');
      dots.className = 'mrg-knife-carousel__dots';
      const dotButtons = slides.map((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'mrg-knife-carousel__dot';
        dot.setAttribute('aria-label', 'Couteau ' + (index + 1));
        dots.appendChild(dot);
        return dot;
      });
      function indexNow() {
        const width = track.clientWidth || 1;
        return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / width)));
      }
      function go(index) {
        const width = track.clientWidth || 1;
        track.scrollTo({ left: index * width, behavior: 'smooth' });
      }
      function paint() {
        const current = indexNow();
        prev.disabled = current === 0;
        next.disabled = current === slides.length - 1;
        dotButtons.forEach((dot, index) => {
          dot.setAttribute('aria-current', index === current ? 'true' : 'false');
        });
      }
      prev.addEventListener('click', () => go(indexNow() - 1));
      next.addEventListener('click', () => go(indexNow() + 1));
      dotButtons.forEach((dot, index) => dot.addEventListener('click', () => go(index)));
      track.addEventListener('scroll', () => paint(), { passive: true });
      carousel.append(prev, next, dots);
      requestAnimationFrame(paint);
    }
    return carousel;
  }

  function mountSlot(slot) {
    if (slot.dataset.mrgKnifeCarousel === 'ready') return;
    const source = slot.closest('.mrg-sheet') && slot.closest('.mrg-sheet').querySelector('.mrg-sheet__source');
    if (!source) return;
    const dimImgs = [...source.querySelectorAll('img')].filter((img) =>
      /dimension/i.test((img.getAttribute('alt') || '') + ' ' + (img.getAttribute('src') || ''))
    );
    let carousel = null;
    if (dimImgs.length) {
      const slides = dimImgs.map((img) => {
        const block = blockFor(img);
        const name = knifeName(block, img);
        return { name, desc: knifeDesc(block, name), img };
      });
      carousel = buildSlides(slides);
    } else {
      const heading = findHeading(source);
      if (!heading) return;
      const end = boundaryAfter(heading, source);
      const imgs = imagesBefore(heading, end);
      if (!imgs.length) return;
      carousel = build(heading, imgs);
    }
    slot.appendChild(carousel);
    slot.dataset.mrgKnifeCarousel = 'ready';
  }

  function boot() {
    document.querySelectorAll('[data-mrg-knife-slot]').forEach(mountSlot);
    document
      .querySelectorAll('.mrg-specs__body, .mrg-product-description-drawer__content')
      .forEach((root) => {
        if (root.querySelector('[data-mrg-knife-slot]')) return;
        mount(root);
      });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
